import request from '@/network/request'
const origin = 'https://wx.sxmfyy.com/home'
export function requestWechatCode() {
  return (
    'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6cfd6f1d50ea07ba&redirect_uri=' +
    encodeURIComponent(origin) +
    '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
  )
}

// 根据code获取公众号用户信息
export function requestWechatInfo(code) {
  return request({
    url: `/api/wechatUser/wechat/auth?code=${code}`,
    method: 'get',
  })
}

// 获取授权信息
export function queryWechatInfo(data) {
  return request({
    url: `/hospitalordering/applet/user/user/jsticket`,
    method: 'post',
    data,
  })
}

// 根据code获取appid
export function queryOpenId(data) {
  return request({
    url: `/app/scanWeixin/adviceInfoAndWxauth`,
    method: 'post',
    data,
  })
}

// 根据appid获取支付信息
export function queryPayInfo(data) {
  return request({
    url: `/sclm/apply/manager/consume/order/findOrderByAdviceCodePayment`,
    method: 'post',
    data,
  })
}
// 获取微信appid
export function queryWechatAppId(data) {
  return request({
    url: `/sclm/apply/app/scanWeixin/adviceInfoAndWxauth`,
    method: 'post',
    data,
  })
}
// 获取微信appid
export function queryWechatOpenId(data) {
  return request({
    url: `/sclm/apply/app/scanWeixin/wechatPayPassword`,
    method: 'post',
    data,
  })
}
